import React from 'react'
import { LuChevronDown, LuChevronUp } from 'react-icons/lu'
import { Box } from '@chakra-ui/react'

import { Button } from './styles'

type Props = {
  isExpanded: boolean
  isWhite?: boolean
  onClick: () => void
}

export const ToggleExpandButton: React.FC<Props> = ({ isExpanded, isWhite, onClick }) => (
  <Button aria-label="Toggle expand text" type="button" onClick={onClick}>
    <Box color="green.a250">{isExpanded ? <LuChevronUp size={16} /> : <LuChevronDown size={16} />}</Box>
  </Button>
)
